import { useState } from 'react';
import { Card, Input, DatePicker, Select, Button } from 'antd';
import dayjs from 'dayjs';
import BreakdownList from '../components/BreakdownList';
import { getUserRole } from '../utils/tokenUtils';
import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';


const Breakdowns = ({ userRole }) => {
  const refreshedRole = getUserRole();
  const [activeQuery, setActiveQuery] = useState('');
  const [activeDateRange, setActiveDateRange] = useState(null);
  const [activeLimit, setActiveLimit] = useState(20);
  const [searchLoading, setSearchLoading] = useState(false);
  const [activeCompany, setActiveCompany] = useState();
  const [companyOptions, setCompanyOptions] = useState([]);
  
  const handleSearchActive = () => {
    setSearchLoading(true);
    setActiveQuery((q) => (typeof q === 'string' ? q.trim() : q));
    setTimeout(() => {
      setSearchLoading(false);
    }, 300);
  };

  return (
    <div className="breakdowns-page">
      <Card
        title="Active Breakdowns Search"
        bordered
        variant="outlined"
        style={{ 
          margin: '16px 16px 0px 16px',
          backgroundColor: '#ffffffff',
          color: '#333',
          borderRadius: '8px',
          display: 'flex',
          minWidth: '120px',
          flexDirection: 'column',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
        extra={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            width="18"
            height="18"
            style={{ color: 'rgba(0,0,0,0.45)' }}
          >
            <path d="M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z" fill="currentColor"></path>
          </svg>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            <DatePicker.RangePicker
              allowClear
              value={activeDateRange}
              onChange={(range) => setActiveDateRange(range)}
              disabledDate={(current) => current && current > dayjs().endOf('day')}
              style={{ minWidth: 260, flex: 1 }}
              placement="bottom"
              popupClassName="mobile-range-picker-dropdown"
              getPopupContainer={() => document.body}
              inputReadOnly
              suffixIcon={<CloseCircleOutlined />}
            />
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            <Select
              allowClear
              placeholder="Filter by company"
              style={{ minWidth: 220, flex: 1 }}
              options={companyOptions}
              value={activeCompany}
              onChange={(value) => setActiveCompany(value || undefined)}
              getPopupContainer={() => document.body}
              disabled={!companyOptions || companyOptions.length === 0}
            />
            <Input
              allowClear
              prefix={<SearchOutlined />}
              placeholder="Reference (e.g RNR1234XYZ-B) / Registration / Fleet"
              value={activeQuery}
              onChange={(e) => setActiveQuery(e.target.value)}
              onPressEnter={handleSearchActive}
              style={{ flex: 1, minWidth: 220 }}
            />
            <div>
              <Select
                value={activeLimit}
                onChange={(v) => setActiveLimit(v)}
                getPopupContainer={() => document.body}
                options={[
                  { label: '5', value: 5 },
                  { label: '10', value: 10 },
                  { label: '20', value: 20 },
                  { label: '50', value: 50 },
                  { label: 'All', value: 'all' }
                ]}
                style={{ marginRight: 8 }}
              />
              <Button type="primary" loading={searchLoading} onClick={handleSearchActive}>Search</Button>
            </div>
          </div>
        </div>
      </Card>
      <BreakdownList
        userRole={userRole || refreshedRole}
        searchTerm={activeQuery}
        dateRange={activeDateRange}
        limit={activeLimit}
        companyFilter={activeCompany}
        onCompanyOptionsChange={setCompanyOptions}
      />
    </div>
  );
};

export default Breakdowns;
